<template>
    <template-block
        v-if="localModel"
        type="Text"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <div class="block-content-grid">
            <select-with-validation
                v-model="localModel.fontSize"
                :vid="vid + '.fontSize'"
                label="Textstorlek"
                :reduce="(opt) => opt.id"
                component="font-size-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.lineHeight"
                :vid="vid + '.lineHeight'"
                label="Radhöjd"
                :reduce="(opt) => opt.id"
                component="font-size-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.fontFamily"
                :vid="vid + '.fontFamily'"
                label="Font"
                :reduce="(opt) => opt.id"
                component="ecard-template-fonts-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <color-picker
                :vid="vid + '.color'"
                label="Textfärg"
                v-model="localModel.color"
                @input="emitChange"
            ></color-picker>
            <color-picker
                :vid="'view.linkColor'"
                label="Länkfärg"
                v-model="localModel.linkColor"
                @input="emitChange"
            ></color-picker>
        </div>
        <simple-text-editor
            v-model="localModel.text"
            :toolbar="[
                'h1',
                'h2',
                'h3',
                'bold',
                'italic',
                'strike',
                'underline',
            ]"
            @input="emitChange"
            :text-class="['text-' + localModel.align]"
        >
            <template #toolbar>
                <div class="ste-menubar__divider"></div>
                <div class="btn-group">
                    <button
                        type="button"
                        class="ste-menubar__button"
                        :class="{ 'is-active': localModel.align === 'left' }"
                        @click="setTextAlign('left')"
                    >
                        <i class="icon-paragraph-left3"></i>
                    </button>
                    <button
                        type="button"
                        class="ste-menubar__button"
                        :class="{ 'is-active': localModel.align === 'center' }"
                        @click="setTextAlign('center')"
                    >
                        <i class="icon-paragraph-center3"></i>
                    </button>
                    <button
                        type="button"
                        class="ste-menubar__button"
                        :class="{ 'is-active': localModel.align === 'right' }"
                        @click="setTextAlign('right')"
                    >
                        <i class="icon-paragraph-right3"></i>
                    </button>
                </div>
            </template>
        </simple-text-editor>
    </template-block>
</template>

<script>
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import SimpleTextEditor from '@components/SimpleTextEditor.vue';
import { genUUID } from '@services/Helpers';
import ColorPicker from '@components/Form/ColorPicker.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';

export default {
    name: 'BlockText',
    components: {
        SelectWithValidation,
        ColorPicker,
        SimpleTextEditor,
        TemplateBlock,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'image.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        localModel: null,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
        fontSize(newVal) {
            this.localModel.lineHeight = newVal + 4;
            this.emitChange();
        },
    },
    methods: {
        init(newVal) {
            this.localModel = {
                type: 'text',
                id: newVal.id || genUUID(),
                text: newVal.text || '##GreetingText##',
                align: newVal.align || 'center',
                color: newVal.color || '#222222',
                linkColor: newVal.linkColor || '#222222',
                fontSize: newVal.fontSize ?? 14,
                lineHeight: newVal.lineHeight ?? 20,
                fontFamily: newVal.fontFamily || 'inherit',
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
        setTextAlign(align) {
            this.localModel.align = align;
            this.emitChange();
        },
    },
};
</script>
